import { filterByName, filterByPrice, filterByBoard } from './filters';

import { paginate } from './pagination';
import { sortHotels } from './ordering';

export const filterAndPaginateHotels = ({
  hotels,
  pageSize,
  pageNumber,
  nameFilter,
  pricesFiltered,
  priceRange,
  totalNights,
  filter,
  orderHotelsBy,
  setQuantityFiltered,
  setPageQuantity,
}) => {
  let filtered = filterByName(hotels, nameFilter);

  filtered = filterByPrice(filtered, pricesFiltered, priceRange, totalNights);

  filtered = filterByBoard(filtered, filter);

  const sorted = sortHotels(filtered, orderHotelsBy);

  const totalPages = Math.ceil(sorted.length / pageSize);
  setQuantityFiltered(sorted.length);

  setPageQuantity(totalPages);

  const paginated = paginate(sorted, pageSize, pageNumber);

  return {
    hotels: paginated,
    filtered: sorted,
  };
};
